import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { useBusiness } from "@/core/business";
import { useGetMyUser } from "@/user/query";
import { EditorWorkspace } from "./editor-workspace";

// The editor renders outside the Settings shell, so it owns the viewport height
// the shell used to give it.
const PAGE_HEIGHT = "h-[calc(100vh-67px)]";

const PayrollEditorPage = () => {
  const { businessId } = useBusiness();
  const { data: user, isPending, isError, refetch } = useGetMyUser();
  // Three different situations, not one. A user still loading, and a user that
  // failed to load, were both reported as "select a business", which is advice
  // about something the reader has already done and cannot act on again.
  if (isPending) return <p className="p-6">Loading…</p>;
  if (isError || !user)
    return (
      <Stack gap="md" className="flex flex-col items-start gap-3 p-6">
        <p role="alert">Your account could not load. Try again.</p>
        <Button size="xs" variant="tertiary" onClick={() => void refetch()}>
          Try again
        </Button>
      </Stack>
    );
  if (!businessId)
    return <p className="p-6">Select a business to view payroll rules.</p>;
  return (
    <div className={`${PAGE_HEIGHT} min-h-0 w-full`}>
      <EditorWorkspace
        key={`${user.id}:${businessId}`}
        userId={user.id}
        businessId={businessId}
      />
    </div>
  );
};

export default PayrollEditorPage;
